module.exports = __webpack_public_path__ + "assets/img/payClose.f08deccd.png";